import z from 'zod';
import { UUIDSchema, UnixTimestampSchema } from '../common/schemas';
import { DBTimestampSchema } from '../common/sql';
import { QuestionFaultOrigin } from './enums';

/**
 * DB Schemas
 */

export const DBQuestionFaultIdSchema = UUIDSchema;
export const DBQuestionFaultOriginSchema = z.enum(QuestionFaultOrigin);
export const DBQuestionFaultCodeSchema = z.string().min(1).max(64);
export const DBQuestionFaultPathSchema = z.string().min(1);
export const DBQuestionFaultMessageSchema = z.string().min(1);

export const DBQuestionFaultSchema = z.object({
  id: DBQuestionFaultIdSchema,
  rootQuestionId: UUIDSchema,
  questionId: UUIDSchema.nullable(),
  origin: DBQuestionFaultOriginSchema,
  code: DBQuestionFaultCodeSchema,
  path: DBQuestionFaultPathSchema,
  message: DBQuestionFaultMessageSchema,
  questionDigitisationRunId: UUIDSchema.nullable(),
  enrichmentRunId: UUIDSchema.nullable(),
  createdAt: DBTimestampSchema,
});

/**
 * Client Schemas
 */

export const QuestionFaultIdSchema = DBQuestionFaultIdSchema;
export const QuestionFaultOriginSchema = DBQuestionFaultOriginSchema.openapi({
  description: 'Which pass over the question found the fault',
  example: QuestionFaultOrigin.Digitisation,
});
export const QuestionFaultCodeSchema = DBQuestionFaultCodeSchema.openapi({
  description: 'A digitisation fault code, or an enrichment park code',
  example: 'marks_do_not_sum',
});
export const QuestionFaultPathSchema = DBQuestionFaultPathSchema.openapi({
  description: "Where the check reported the fault, in the paper's own labels",
  example: '12(b)(ii)',
});
export const QuestionFaultMessageSchema = DBQuestionFaultMessageSchema.openapi({
  description: "The check's own wording",
  example: "12(b)(ii)'s criteria add up to 3 marks, and the part is worth 2",
});

export const QuestionFaultSchema = z.object({
  id: QuestionFaultIdSchema,
  rootQuestionId: UUIDSchema,
  questionId: UUIDSchema.nullable().openapi({
    description:
      'The part the fault is on, where its path names exactly one. Null for the whole question.',
  }),
  origin: QuestionFaultOriginSchema,
  code: QuestionFaultCodeSchema,
  path: QuestionFaultPathSchema,
  message: QuestionFaultMessageSchema,
  questionDigitisationRunId: UUIDSchema.nullable(),
  enrichmentRunId: UUIDSchema.nullable(),
  createdAt: UnixTimestampSchema,
});
